module.exports = __webpack_public_path__ + "img/img58.6cee22fd.png";